import React from "react";
import { EditButton, List, TextField } from "react-admin";
import StatusField from "../../../bookmaker-channels/fields/StatusField";
import CopyLinkButton from "../../../channels/CopyLinkButton";
import { ChannelsBulkActions } from "../../../channels/CopyLinksButton";
import ResponsiveList from "../../../components/lists/ResponsiveList";
import { useListStyles } from "../../../components/lists/useStyles";
import useNetwork from "../../../useNetwork";
import { getCommonListProps } from "./";

const ChannelsList = (props) => {
	const classes = useListStyles();
	const { network } = useNetwork();
	return (
		<List
			resource="bookmaker-channels"
			basePath="/bookmaker-channels"
			classes={classes}
			{...getCommonListProps(props)}
			bulkActionButtons={<ChannelsBulkActions network={network} />}
		>
			<ResponsiveList>
				<TextField source="id" label="ID" style={{ fontWeight: "bold" }} />
				<TextField
					source="name"
					label="resources.bookmaker-channels.fields.name"
				/>
				<TextField
					source="remote_id"
					label="resources.bookmaker-channels.fields.remote_id"
				/>
				<TextField
					source="remote_name"
					label="resources.bookmaker-channels.fields.remote_name"
				/>
				<TextField
					source="user.name"
					label="resources.bookmaker-channels.fields.user.name"
				/>
				<StatusField
					source="status"
					label="resources.bookmaker-channels.fields.status"
				/>
				<EditButton />
				<CopyLinkButton
					network={network}
					source="hash"
					label=""
					sortable={false}
				/>
			</ResponsiveList>
		</List>
	);
};

export default ChannelsList;
